import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";

// Images
import team1 from "../../img/team-1.jpg";
import team2 from "../../img/team-2.jpg";
import team3 from "../../img/team-3.jpg";
import team4 from "../../img/team-4.jpg";

const TeamCard = ({ image, name, role }) => (
  <div className="bg-light rounded text-center p-4">
    <div className="mb-3">
      <img
        src={image}
        alt={name}
        className="rounded-circle border border-success border-3"
        style={{ width: "120px", height: "120px", objectFit: "cover" }}
      />
    </div>
    <h5 className="mb-1">{name}</h5>
    <p className="text-muted mb-2">{role}</p>
    <div className="d-flex justify-content-center gap-2">
      <a href="#" className="btn btn-outline-success btn-sm rounded-circle">
        <i className="fab fa-facebook-f"></i>
      </a>
      <a href="#" className="btn btn-outline-success btn-sm rounded-circle">
        <i className="fab fa-twitter"></i>
      </a>
      <a href="#" className="btn btn-outline-success btn-sm rounded-circle">
        <i className="fab fa-instagram"></i>
      </a>
      <a href="#" className="btn btn-outline-success btn-sm rounded-circle">
        <i className="fab fa-linkedin-in"></i>
      </a>
    </div>
  </div>
);

const Team = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="container py-5" id="team">
      <div className="text-center mb-5" data-aos="fade-up">
        <h5 className="text-primary">Our Team</h5>
        <h2 className="fw-bold">Meet our expert Team</h2>
      </div>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        autoplay={{ delay: 3000 }}
        loop={true}
        breakpoints={{
          320: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
        }}
        data-aos="fade-up"
      >
        <SwiperSlide>
          <TeamCard image={team1} name="Ruhi Dwivedi" role="Java Developer" />
        </SwiperSlide>
        <SwiperSlide>
          <TeamCard image={team2} name="Akash Varma" role="Mobile App Developer" />
        </SwiperSlide>
        <SwiperSlide>
          <TeamCard image={team3} name="Ritika" role="Web Developer" />
        </SwiperSlide>
        <SwiperSlide>
          <TeamCard image={team4} name="Sumit Gupta" role="Fullstack Developer" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Team;
